<div id="wp-container" *ngIf="sectionHtml">
  <div [innerHTML]="sectionHtml"></div>
</div>
